import React, { Component } from "react";

export default class Square extends Component {
  render() {
    return (
      <button className="square" onClick={() => this.props.onClick()}>
        <img src={this.props.element} style={{ display: this.props.display }} />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Square.js